import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import reducer from "../redux/reducer";
import localStorage from "redux-persist/lib/storage";
import { composeWithDevTools } from "redux-devtools-extension";

// Only load redux-logger in development
const middleware = [];
//console.log("NODE_ENV:", process.env.NODE_ENV); 
if (process.env.NODE_ENV === "development") {
  const { createLogger } = require("redux-logger");
  
  middleware.push(
    createLogger({
      collapsed: true, // cleaner logs
      duration: true, // action timing
      diff: false, // disable detailed diff if not needed
    })
  );
}

const persistConfig = {
  key: "root",
  storage: localStorage,
};

const persistedReducer = persistReducer(persistConfig, reducer);

const configureStore = () => {
  const store = createStore(
    persistedReducer,
    process.env.NODE_ENV === "development"
      ? composeWithDevTools(applyMiddleware(...middleware))
      : applyMiddleware(...middleware)
  );

  const persistor = persistStore(store);

  return { store, persistor };
};

export default configureStore;

/** Previous version with logger always included */ 
// import { createStore, applyMiddleware } from "redux";
// import logger from "redux-logger";
// import { persistStore, persistReducer } from "redux-persist";
// import reducer from "../redux/reducer";
// import localStorage from "redux-persist/lib/storage";
// import {composeWithDevTools} from "redux-devtools-extension";

// const middleware = [logger];
// const persistConfig = {
//   key: "root",
//   storage: localStorage,
// };
// const persistedReducer = persistReducer(persistConfig, reducer , composeWithDevTools());

// const configureStore = () => {
//   const store = createStore(
//     persistedReducer,
//     composeWithDevTools(applyMiddleware(...middleware))
//   );
//   const persistor = persistStore(store);

//   return { store, persistor };
// };

// export default configureStore;

